import { TemplateRef, } from '@angular/core';
var UiInfoCardComponent = /** @class */ (function () {
    function UiInfoCardComponent() {
        this.direction = 'vertical';
    }
    Object.defineProperty(UiInfoCardComponent.prototype, "isCompactView", {
        get: function () {
            return this.entries && this.entries.length > 4;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiInfoCardComponent.prototype, "isOdd", {
        get: function () {
            return this.entries.length % 2 === 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiInfoCardComponent.prototype, "hasSibling", {
        get: function () {
            return this.entries.length > 1;
        },
        enumerable: true,
        configurable: true
    });
    UiInfoCardComponent.prototype.isFirst = function (index) {
        return index === 0;
    };
    UiInfoCardComponent.prototype.isRightSide = function (index) {
        if (this.isOdd) {
            return index % 2 === 0;
        }
        return index % 2 !== 0;
    };
    return UiInfoCardComponent;
}());
export { UiInfoCardComponent };
